export const INIT_TIMBRATURE = 'INIT_TIMBRATURE';
export const INIT_REQUEST = 'INIT_REQUEST';

export const ADD_TIMBRATURA_AUTOMATICA_ACTION = 'ADD_TIMBRATURA_AUTOMATICA_ACTION';
export const ADD_TIMBRATURA_AUTOMATICA_END = 'ADD_TIMBRATURA_AUTOMATICA_END';
export const ADD_TIMBRATURA_AUTOMATICA_SUCCESS = 'ADD_TIMBRATURA_AUTOMATICA_SUCCESS';
export const ADD_TIMBRATURA_AUTOMATICA_FAIL = 'ADD_TIMBRATURA_AUTOMATICA_FAIL';

export const ADD_TIMBRATURA_MANUALE_ACTION = 'ADD_TIMBRATURA_MANUALE_ACTION';
export const ADD_TIMBRATURA_MANUALE_END = 'ADD_TIMBRATURA_MANUALE_END';
export const ADD_TIMBRATURA_MANUALE_SUCCESS = 'ADD_TIMBRATURA_MANUALE_SUCCESS';
export const ADD_TIMBRATURA_MANUALE_FAIL = 'ADD_TIMBRATURA_MANUALE_FAIL';

export const RICERCA_TIMBRATURE_SINGOLO_INDIVIDUO_ACTION = 'RICERCA_TIMBRATURE_SINGOLO_INDIVIDUO_ACTION';
export const RICERCA_TIMBRATURE_SINGOLO_INDIVIDUO_END = 'RICERCA_TIMBRATURE_SINGOLO_INDIVIDUO_END';
export const GET_TIMBRATURE_SINGOLO_INDIVIDUO_SUCCESS = 'GET_TIMBRATURE_SINGOLO_INDIVIDUO_SUCCESS';
export const GET_TIMBRATURE_SINGOLO_INDIVIDUO_FAIL = 'GET_TIMBRATURE_SINGOLO_INDIVIDUO_FAIL';

export const DELETE_TIMBRATURA_ACTION = 'DELETE_TIMBRATURA_ACTION';
export const DELETE_TIMBRATURA_SUCCESS = 'DELETE_TIMBRATURA_SUCCESS';
export const DELETE_TIMBRATURA_FAIL = 'DELETE_TIMBRATURA_FAIL';

export const TIMBRATURA_RECUPERA_DETTAGLIO = 'TIMBRATURA_RECUPERA_DETTAGLIO';
export const TIMBRATURA_RECUPERA_DETTAGLIO_SUCCESS = 'TIMBRATURA_RECUPERA_DETTAGLIO_SUCCESS';
export const INVERTI_TIMBRATURA = 'INVERTI_TIMBRATURA';








